<template>
  <div
    :class="{
      'container mx-auto': true,
    }"
    data-testid="LpHeader"
  >
    <HeaderLogo
      v-bind="props"
      :light="props.light"
      :class="{
        'mx-auto mt-60px': true,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Header } from '~/sanity/types';
import HeaderLogo from '~/components/Molecules/HeaderComponents/HeaderLogo.vue';

interface Props extends Header {
  light?: boolean;
}
const props = defineProps<Props>();
</script>

<style></style>
